<!-- <app-location-details></app-location-details> -->
<div class="address-container">
  <h2>Address</h2>

  <div class="upload-section">
    <!-- <label for="fileInput" class="upload-btn">
        <i class="pi pi-cloud-upload"></i>
        Upload address proof
      </label>
      <input
        id="fileInput"
        type="file"
        style="display: none"
        (change)="onFileSelected($event)"
      /> -->
      <form [formGroup]="form" >
        <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
      </form>
    </div>
    <button pButton type="button" class="btn-primary mt-6" (click)="onFinish()">Next <i class="pi pi-arrow-right arrow-icon" style="margin-left: 8px;"></i></button>
    <!-- <button pButton type="button" class="finish-btn" (click)="navigateTo()">Finish</button> -->
  </div>
  <!-- <button pButton type="button" class="finish-btn" (click)="navigateTo()">Finish</button> -->
